export const SAVE_CITY_MASTER = "SAVE_CITY_MASTER"
export const SAVE_CITY_MASTER_SUCCESS = "SAVE_CITY_MASTER_SUCCESS"

export const GET_CITY_LIST = "GET_CITY_LIST"
export const GET_CITY_LIST_SUCCESS = "GET_CITY_LIST_SUCCESS"

export const CITY_API_ERROR_ACTION = "CITY_API_ERROR_ACTION"

